import { Col, Row } from "antd";
import { getColor } from "../resources/theme";
import React from "react";
import styled from "styled-components";

export const ScreenLayout = ({
	children,
	data,
	title,
	description,
	contentAligned,
}) => {
	return (
		<>
			<Header>
				<Row>
					<Col>
						<Title>{title}</Title>
					</Col>
				</Row>
				<Row>
					<Col>
						<Description>{description}</Description>
					</Col>
				</Row>
			</Header>
			<Content contentAligned={contentAligned}>{children}</Content>
		</>
	);
};

const Header = styled.div`
	padding: 36px 180px;
`;

const Content = styled.div`
	${({ contentAligned }) => contentAligned && "padding: 24px 180px;"}
`;

const Title = styled.h2`
	color: ${getColor("primary")};
	margin-bottom: 16px;
`;

const Description = styled.h4`
	color: ${getColor("primary")};
`;
